import React from 'react';
import { Users, ShieldCheck, Leaf, Award } from 'lucide-react';
export function TrustBar() {
  return <section className="w-full py-8 px-4 bg-forest text-cream-card border-y-4 border-forest-light" data-id="element-179">
      <div className="max-w-5xl mx-auto" data-id="element-180">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-181">
          <div className="flex flex-col items-center gap-2" data-id="element-182">
            <Users className="w-8 h-8 opacity-90" data-id="element-183" />
            <span className="font-serif text-sm md:text-base font-medium" data-id="element-184">
              80.000+ zufriedene Kunden
            </span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-185">
            <Award className="w-8 h-8 opacity-90" data-id="element-186" />
            <span className="font-serif text-sm md:text-base font-medium" data-id="element-187">
              Von Tierärzten empfohlen
            </span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-188">
            <Leaf className="w-8 h-8 opacity-90" data-id="element-189" />
            <span className="font-serif text-sm md:text-base font-medium" data-id="element-190">
              100% pflanzlich & natürlich
            </span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-191">
            <ShieldCheck className="w-8 h-8 opacity-90" data-id="element-192" />
            <span className="font-serif text-sm md:text-base font-medium" data-id="element-193">
              Geld-zurück-Garantie
            </span>
          </div>
        </div>
      </div>
    </section>;
}